import { Alert, Box, CssBaseline, Link, Toolbar, useMediaQuery } from "@mui/material";
import React from "react";
import Header from "./Header";
import { useTheme } from "@emotion/react";
import MobileNavigation from "./MobileNavigation";
import MobileHeader from "./MobileHeader";

const Layout = ({ children }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Box sx={{ display: "flex", flexDirection: "column", minHeight: "100vh", background: "secondary.100" }}>
      <CssBaseline />
      { isMobile ? <MobileHeader /> : <Header />}
      <Alert severity="info" sx={{ justifyContent: "center" }}>
        This is a beta version of ORSEE 2.0. Some features may be missing or not work as expected. Please report any issues to the <Link href="mailto:explab@unil.ch" sx={{color: "text.primary", fontWeight: "bold"}}> support team</Link> or 
        <Link href={process.env.REACT_APP_PUBLIC_URL} sx={{color: "text.primary", fontWeight: "bold"}}> switch back to orsee 1.0</Link>.
      </Alert>
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          backgroundColor: "secondary.100",
          padding: {
            sm: "0px",
          },
        }}
      >        
          <Toolbar />
          {children}
        {isMobile && <MobileNavigation />}
      </Box>
    </Box>
  );
};

export default Layout;